export default __webpack_public_path__ + "static/media/Group9161.a59ff6be.svg";